import * as React from "react";

const FacebookIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="42"
        height="42"
        fill="none"
        viewBox="0 0 50 50"
    >
        <rect width="50" height="50" fill="#36387D" rx="8"></rect>
        <path
            fill="#fff"
            d="M38 25.048C38 17.842 32.18 12 25 12s-13 5.842-13 13.048a13.044 13.044 0 0 0 9.86 12.663v-8.676h-2.68v-3.987h2.68V23.33c0-4.441 2.002-6.5 6.346-6.5.824 0 2.245.163 2.826.324v3.615c-.306-.033-.84-.049-1.501-.049-2.132 0-2.955.81-2.955 2.918v1.41h4.246l-.73 3.987h-3.516V38C33.012 37.22 38 31.719 38 25.048"
        ></path>
    </svg>
);

export default FacebookIcon;
